import { Controller } from "@hotwired/stimulus"

// Toggles the "course picker" subform visibility based on the selected
// LiveEvent visibility radio. Also keeps the visual `is-selected` state
// of the visibility cards in sync.
export default class extends Controller {
  static targets = ["card", "radio", "coursePicker"]

  connect() {
    this.update()
  }

  update() {
    const selected = this.radioTargets.find(r => r.checked)?.value
    this.cardTargets.forEach(card => {
      card.classList.toggle("is-selected", card.dataset.visibilityKey === selected)
    })
    if (this.hasCoursePickerTarget) {
      this.coursePickerTarget.classList.toggle("hidden", selected !== "course_private")
    }
  }
}
